const MONTH_MAP: Record<string, number> = {
    jan: 1, january: 1,
    feb: 2, february: 2,
    mar: 3, march: 3,
    apr: 4, april: 4,
    may: 5,
    jun: 6, june: 6,
    jul: 7, july: 7,
    aug: 8, august: 8,
    sep: 9, september: 9, sept: 9,
    oct: 10, october: 10,
    nov: 11, november: 11,
    dec: 12, december: 12
}

interface ParsedDate {
    month: number
    year: number
    value: number
}

interface MonthEntry {
    label: string
    value: number
}

export function parseDateInput(text: string): ParsedDate | null {
    if (!text || typeof text !== 'string') return null
    const trimmed = text.trim()
    if (!trimmed) return null

    const parts = trimmed.split(/[\s,/\-]+/)
    if (parts.length < 2) return null

    let monthNum: number | null = null
    let year: number | null = null

    for (let i = 0; i < parts.length; i++) {
        const lower = parts[i].toLowerCase()
        if (MONTH_MAP[lower] !== undefined) {
            monthNum = MONTH_MAP[lower]
        } else {
            const num = parseInt(parts[i], 10)
            if (!isNaN(num)) {
                if (num >= 1900 && num <= 2100) {
                    year = num
                } else if (num >= 1 && num <= 12 && monthNum === null) {
                    monthNum = num
                }
            }
        }
    }

    if (monthNum !== null && year !== null) {
        return { month: monthNum, year: year, value: year * 100 + monthNum }
    }
    return null
}

export function findClosestMonthIndex(monthList: MonthEntry[], targetValue: number): number {
    if (!monthList || !monthList.length) return -1

    let closestIdx = -1
    let closestDiff = Infinity

    for (let i = 0; i < monthList.length; i++) {
        if (monthList[i].value === targetValue) return i
        const diff = Math.abs(monthList[i].value - targetValue)
        if (diff < closestDiff) {
            closestDiff = diff
            closestIdx = i
        }
    }
    return closestIdx
}
